import EmptyContent from 'components/EmptyContent';
import Preloader from 'components/Preloader';
import QuestionnaireGroup from 'components/QuestionnaireGroup';
import React from 'react';

import './InvestorProfileBase.css';

export const InvestorProfileBase = ({
    errors,
    isLoading,
    investorProfileGroup,
    title,
    values,
    onChange,
    data,
    t,
}) => (
    <div className="new-portfolio">
        <Preloader
            isLoading={isLoading}
        >
            <div className="new-portfolio-content">
                <EmptyContent data={data} text={t('advisoryDashboard.noData')}>
                    <QuestionnaireGroup
                        data={investorProfileGroup}
                        title={title}
                        value={values || {}}
                        errors={errors}
                        onChange={onChange}
                    />
                </EmptyContent>
            </div>
        </Preloader>
    </div>
);
